import { PluginContainerData_Alignment, PluginContainerData_Width_Type, Node_Type } from 'ricos-schema';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { Component, useContext } from 'react';
import classNames from 'classnames';
import { uniqueId, includes, get, isFunction, isNumber, upperFirst, camelCase } from 'lodash';
import { addAnchorTagToUrl, anchorScroll, isSSR } from 'wix-rich-content-common';
import { Image as Image$2 } from 'wix-rich-content-ui-components';
import { RicosViewerContext, RicosContext } from 'ricos-context';

const IMAGE_TYPE = "wix-draft-plugin-image";

const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
({
  settings: `${Node_Type.IMAGE}.settings`,
  imageEditor: `${Node_Type.IMAGE}.imageEditor`
});
({
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
});

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const expand = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$3({ viewBox: "0 0 19 19", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.071 8.371V4.585l-4.355 4.356a.2.2 0 0 1-.283 0l-.374-.374a.2.2 0 0 1 0-.283l4.356-4.355h-3.786a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2H16v5.371a.2.2 0 0 1-.2.2h-.529a.2.2 0 0 1-.2-.2zm-6.5 6.9v.529a.2.2 0 0 1-.2.2H3v-5.371c0-.11.09-.2.2-.2h.529c.11 0 .2.09.2.2v3.786l4.355-4.356a.2.2 0 0 1 .283 0l.374.374a.2.2 0 0 1 0 .283L4.585 15.07h3.786c.11 0 .2.09.2.2z",
    fill: "#000",
    fillRule: "nonzero"
  }
));

var styles$2 = {"fontElementMap":"_6uMmy","inPluginInput":"cc-lD"};

class InPluginInput extends Component {
  constructor() {
    super(...arguments);
    this.handleFocus = (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    };
    this.handleBlur = () => this.props.setInPluginEditingMode(false);
    this.handleKeyPress = (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    };
    this.onChange = (e) => {
      var _a, _b;
      return (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, e.target.value);
    };
  }
  render() {
    const className = classNames(styles$2.inPluginInput, this.props.className);
    return /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className,
        value: this.props.value,
        onChange: this.onChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        dir: "auto",
        rows: 1
      }
    );
  }
}
InPluginInput.defaultProps = {
  setInPluginEditingMode: () => false,
  setFocusToBlock: () => false
};

var styles$1 = {"fontElementMap":"dFtRw","imageContainer":"uDtJC","expandContainer":"gVylM","expandIcon":"_2fKYb","pointer":"_0HOIe","imageWrapper":"Vle4X","imageRatio":"HUHRW","image":"Nz4kS","imageOverlay":"Brngn","imageCaption":"TAxqy","imagePreload":"_30gxP","imageHighres":"_8M6pn","onlyHighRes":"fpzlu","image_loading":"FiFr-"};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const IMAGE_FALLBACK_WIDTH = 300;
const getImageSrc = (src, customGetImageUrl) => {
  if (typeof src !== "object") {
    return src;
  }
  if (src == null ? void 0 : src.url) {
    return src.url;
  } else if (src == null ? void 0 : src.id) {
    if (customGetImageUrl) {
      return customGetImageUrl({ file_name: src.id });
    }
    return src.id;
  }
  return "";
};
class ImageViewer extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpand = (e) => {
      var _a;
      e.preventDefault();
      const {
        settings: { onExpand },
        helpers = {}
      } = this.props;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, IMAGE_TYPE, "Click", "expand_image");
      this.hasExpand() && (onExpand == null ? void 0 : onExpand(this.props.node.id));
    };
    this.scrollToAnchor = (e) => {
      const {
        node: { imageData: { link } = {} },
        customAnchorScroll
      } = this.props;
      const anchor = link == null ? void 0 : link.anchor;
      if (customAnchorScroll) {
        return customAnchorScroll(e, anchor);
      }
      const anchorString = `viewer-${anchor}`;
      const element = document.getElementById(anchorString);
      if (!element) {
        return;
      }
      addAnchorTagToUrl(anchorString);
      anchorScroll(element);
    };
    this.hasLink = () => {
      var _a, _b;
      return (_b = (_a = this.props.node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.url;
    };
    this.hasAnchor = () => {
      var _a, _b;
      return (_b = (_a = this.props.node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.anchor;
    };
    this.onKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        this.handleClick(e);
      }
    };
    this.handleClick = (e) => {
      if (this.hasLink()) {
        return null;
      } else if (this.hasAnchor()) {
        e.preventDefault();
        e.stopPropagation();
        this.scrollToAnchor(e);
      } else {
        this.handleExpand(e);
      }
    };
    this.handleContextMenu = (e) => {
      const {
        node: { imageData: { disableDownload = false } = {} }
      } = this.props;
      return disableDownload && e.preventDefault();
    };
    this.hasExpand = () => {
      const {
        node: { imageData },
        settings
      } = this.props;
      let disableExpand = false;
      if ((imageData == null ? void 0 : imageData.disableExpand) !== void 0) {
        disableExpand = imageData.disableExpand;
      } else if (settings.disableExpand !== void 0) {
        disableExpand = settings.disableExpand;
      }
      return !disableExpand && settings.onExpand;
    };
    this.renderExpandIcon = () => {
      return /* @__PURE__ */ React.createElement("div", { className: styles$1.expandContainer }, /* @__PURE__ */ React.createElement(expand, { className: styles$1.expandIcon, onClick: this.handleExpand }));
    };
    this.getImgSize = (imgSrc) => {
      const newImg = new Image();
      newImg.onload = () => this.setState({ dimensions: { width: newImg.width, height: newImg.height } });
      newImg.src = imgSrc;
    };
    this._id = uniqueId("new-image");
  }
  getImageDataUrl() {
    return this.props.dataUrl ? this.props.dataUrl : null;
  }
  renderCaption(caption) {
    const { onCaptionChange, setFocusToBlock } = this.props;
    const classes = classNames(styles$1.imageCaption, this.hasLink() && styles$1.link);
    return onCaptionChange ? /* @__PURE__ */ React.createElement(
      InPluginInput,
      {
        className: classes,
        value: caption,
        onChange: onCaptionChange,
        setFocusToBlock
      }
    ) : /* @__PURE__ */ React.createElement("span", { dir: "auto", className: classes }, caption);
  }
  shouldRenderCaption() {
    var _a, _b, _c, _d;
    const { settings, node, defaultCaption } = this.props;
    const caption = (_a = node.imageData) == null ? void 0 : _a.caption;
    if (includes(get(settings, "toolbar.hidden"), "settings")) {
      return false;
    }
    if (!caption || caption === defaultCaption) {
      return false;
    }
    const { containerData } = node.imageData || RICOS_DEFAULTS;
    if (((_b = containerData == null ? void 0 : containerData.width) == null ? void 0 : _b.size) === "ORIGINAL" && ((_d = (_c = node.imageData) == null ? void 0 : _c.image) == null ? void 0 : _d.width)) {
      return node.imageData.image.width >= 350;
    }
    return true;
  }
  // eslint-disable-next-line complexity
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const {
      node,
      className,
      settings,
      setComponentUrl,
      helpers,
      isMobile,
      seoMode,
      accessibilityProps,
      onCaptionChange
    } = this.props;
    const { containerData } = node.imageData || RICOS_DEFAULTS;
    const { image, altText } = node.imageData || {};
    const { src, width, height } = image || {};
    const itemClassName = classNames(styles$1.imageWrapper, styles$1.imageRatio, className, {
      [styles$1.pointer]: this.hasExpand()
    });
    const imageSrc = this.getImageDataUrl() || getImageSrc(src, helpers == null ? void 0 : helpers.getImageUrl) || "";
    let imageProps = {};
    if (src && settings && settings.imageProps) {
      imageProps = isFunction(settings.imageProps) ? settings.imageProps({ url: src.url, file_name: src.id, width, height }) : settings.imageProps;
    }
    const socialAttrs = {};
    ["data-pin-nopin", "data-pin-url", "data-pin-media"].forEach(
      (attr) => imageProps[attr] && (socialAttrs[attr] = imageProps[attr])
    );
    setComponentUrl == null ? void 0 : setComponentUrl(imageSrc);
    const usePredefinedWidth = ((containerData == null ? void 0 : containerData.alignment) === "LEFT" || (containerData == null ? void 0 : containerData.alignment) === "RIGHT") && !((_a = containerData.width) == null ? void 0 : _a.custom) && ((_b = containerData.width) == null ? void 0 : _b.size) !== "SMALL" && ((_c = containerData.width) == null ? void 0 : _c.size) !== "ORIGINAL" && !isMobile;
    const dim = {
      width: width || ((_d = containerData == null ? void 0 : containerData.width) == null ? void 0 : _d.custom) || ((_e = this.state) == null ? void 0 : _e.dimensions.width),
      height: height || ((_f = containerData == null ? void 0 : containerData.height) == null ? void 0 : _f.custom) || ((_g = this.state) == null ? void 0 : _g.dimensions.height)
    };
    const isDimensionsExists = dim.width && dim.height;
    if (!isDimensionsExists && !isSSR()) {
      this.getImgSize(imageSrc);
    }
    const customWidthStyle = ((_h = containerData == null ? void 0 : containerData.width) == null ? void 0 : _h.size) === "ORIGINAL" || isMobile && (Number((_i = containerData == null ? void 0 : containerData.width) == null ? void 0 : _i.custom) || 0) > 150 ? { width: width != null ? width : "0px", maxWidth: "100%" } : {};
    const isEditor = !!onCaptionChange;
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues$2({
        "data-hook": "imageViewer",
        className: styles$1.imageContainer,
        onContextMenu: this.handleContextMenu,
        onKeyDown: this.onKeyDown
      }, accessibilityProps),
      /* @__PURE__ */ React.createElement("div", { "aria-label": altText, onClick: this.handleClick, onKeyDown: this.onKeyDown }, isDimensionsExists && /* @__PURE__ */ React.createElement(
        Image$2,
        __spreadValues$2({
          id: imageSrc,
          containerId: this._id,
          displayMode: "fill",
          width: dim.width,
          height: dim.height,
          uri: imageSrc,
          alt: altText || "",
          containerProps: {
            className: itemClassName,
            containerId: this._id,
            style: __spreadValues$2(__spreadValues$2({
              ["--dim-height"]: dim.height,
              ["--dim-width"]: dim.width
            }, usePredefinedWidth && { width: IMAGE_FALLBACK_WIDTH + "px" }), customWidthStyle)
          },
          imageStyles: {
            maxWidth: "100%"
          },
          socialAttrs,
          isSEOBot: !!seoMode
        }, !isEditor ? {
          placeholderTransition: seoMode ? void 0 : "blur",
          shouldUseLQIP: !settings.disableTransition
        } : {})
      ), this.hasExpand() && this.renderExpandIcon()),
      this.shouldRenderCaption() && this.renderCaption((_j = node.imageData) == null ? void 0 : _j.caption)
    );
  }
}

var styles = {"alignLeft":"vGXYB","textWrapNowrap":"JtecM","alignRight":"O21OV","alignCenter":"_9IdiB","sizeFullWidth":"_5iO18","renderedInTable":"UCBNK","sizeOriginal":"fidhP","sizeContent":"MEAos","sizeSmall":"qwdkF","sizeSmallCenter":"cP7Pt","flex":"ZoDKn"};

const alignmentClassName = (node) => {
  var _a, _b;
  const { alignment, width } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (!alignment) {
    return "";
  }
  let align = alignment;
  if ((width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL && alignment !== PluginContainerData_Alignment.CENTER) {
    const { width: width2 } = ((_b = node.imageData) == null ? void 0 : _b.image) || {};
    if (isNumber(width2) && width2 > 350) {
      align = PluginContainerData_Alignment.CENTER;
    }
  }
  return styles[`align${upperFirst(align.toLowerCase())}`];
};
const sizeClassName = (node, isMobile) => {
  var _a;
  const { width } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (!(width == null ? void 0 : width.size) || isMobile && (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL) {
    return "";
  }
  return (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.FULL_WIDTH ? styles.sizeFullWidth : styles[`size${upperFirst(camelCase(width.size.toLowerCase()))}`];
};
const textWrapClassName = (node) => {
  var _a;
  const { textWrap } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Image$1 = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile, experiments, t } = useContext(RicosContext);
  const settings = config[IMAGE_TYPE];
  const hasLink = () => {
    var _a, _b, _c, _d;
    return ((_b = (_a = node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.url) || ((_d = (_c = node.imageData) == null ? void 0 : _c.link) == null ? void 0 : _d.anchor);
  };
  const hasExpandMode = () => {
    var _a;
    return !(settings.disableExpand || ((_a = node.imageData) == null ? void 0 : _a.disableExpand));
  };
  const accessibilityProps = hasLink() || hasExpandMode() ? { role: "button", tabIndex: 0 } : {};
  return /* @__PURE__ */ React.createElement(
    NodeViewContainer,
    {
      node,
      nodeIndex,
      customClassNames: {
        alignment: alignmentClassName(node),
        size: sizeClassName(node, isMobile),
        textWrap: textWrapClassName(node)
      }
    },
    /* @__PURE__ */ React.createElement(
      ImageViewer,
      {
        node,
        settings,
        seoMode,
        helpers,
        accessibilityProps,
        isMobile,
        experiments,
        defaultCaption: t("ImageViewer_Caption")
      }
    )
  );
};
const ImageRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Image$1, __spreadValues$1({ key: node.id, node }, props));
};

const nodeViewRenderers = {
  [Node_Type$1.IMAGE]: ImageRenderer
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginImage = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: IMAGE_TYPE,
    nodeViewRenderers
  };
};

export { IMAGE_TYPE, pluginImage };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-image/dist/es/styles.viewer.min.global.css'